export default "__VITE_ASSET__FrI00pJO__"